import React, { useRef, useEffect } from 'react'
import Homebanner from '../components/Home/Homebanner'
import Navbar from '../common/Navbar'
import HomeContent from '../components/Home/HomeContent'
import Footer from '../common/Footer'
import { useLocation } from 'react-router-dom'


const Home = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location; const containerId = search.substring(4);
    const element = document.getElementById(containerId);
    if (element) {
      const headerHeight = document.querySelector("nav")?.offsetHeight || 80;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementPosition - headerHeight,
        behavior: "smooth",
        inline: "center", block: "start",
      });
    }
  }, [location]);
  return (
    <div>
      <Navbar />
      <Homebanner />
      <HomeContent />
      <Footer />
    </div>
  )
}

export default Home
